import { render, staticRenderFns } from "./InsuranceDescription.vue?vue&type=template&id=5a357138&scoped=true&"
import script from "./InsuranceDescription.vue?vue&type=script&lang=ts&"
export * from "./InsuranceDescription.vue?vue&type=script&lang=ts&"
import style0 from "./InsuranceDescription.vue?vue&type=style&index=0&id=5a357138&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a357138",
  null
  
)

export default component.exports